<template>
  <component :is="component" />
</template>

<script>
import GlobalGoals from '@/components/sidepanels/GlobalGoals';
import PlatformSlider from '@/components/sidepanels/PlatformSlider';
import TimeLine from '@/components/sidepanels/TimeLine';

export default {
  name: 'SidePanel',
  components: {
    GlobalGoals,
    PlatformSlider,
    TimeLine
  },
  computed: {
    component() {
      return this.$store.state.sidepanel;
    }
  }
}
</script>

<style>

</style>
